export {
  FontColor,
  FontSize,
  FontStyle,
  FontType,
  FontWeight,
  TextAlign,
  TextComponent,
  TextTransform,
} from './text.component';
